import {
  CloudflareDataAction,
  LOAD_CLOUDFLARE_DATA,
  LOAD_CLOUDFLARE_DATA_FAIL,
  LOAD_CLOUDFLARE_DATA_SUCCESS,
  LoadCloudflareData,
  LoadCloudflareDataFail,
  LoadCloudflareDataSuccess,
  SET_ENTERPRISE_CDN_DISABLED,
  SET_FULL_PAGE_CACHE_DISABLED,
  SET_ORIGINAL_RECORD_VALUE,
  SET_SETTINGS_VALUES,
  SetClodFlareOriginalRecord,
  SetToggleEnterPriceCDNDisabled
} from '../actions/cloudflare-data.action';
import {CloudflareData} from '../../websites/website/booster/mappers/cloudflare/cloudflare-data';
import {
  SetFullPageCacheDisabled,
  SetSettingsValues
} from "../actions";

export interface ICloudflareDataEntityState {
  cloudflareData: CloudflareData;
  loading: boolean;
  loaded: boolean;
}

export interface ICloudflareDataState {
  [websiteId: number]: ICloudflareDataEntityState;
}

export const initialState: ICloudflareDataState = {};


export function reducer(state: ICloudflareDataState = initialState, action: CloudflareDataAction): ICloudflareDataState {
  let payload: any;

  switch (action.type) {

    case LOAD_CLOUDFLARE_DATA:
      payload = (<LoadCloudflareData>action).payload;

      return {
        ...state,
        [payload.websiteId]: {
          ...state[payload.websiteId],
          loading: true,
          loaded: false,
        }
      };

    case LOAD_CLOUDFLARE_DATA_SUCCESS:
      payload = (<LoadCloudflareDataSuccess>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          cloudflareData: payload.entities,
          loading: false,
          loaded: true,
        }
      };

    case SET_ENTERPRISE_CDN_DISABLED:
      payload = (<SetToggleEnterPriceCDNDisabled>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          cloudflareData: {
            ...state[payload.websiteId].cloudflareData,
            cacheRules: {
              ...state[payload.websiteId].cloudflareData.cacheRules,
              disableCdn: payload.cdnDisabled
            }
          },
          loading: false,
          loaded: true,
        }
      };

    case SET_ORIGINAL_RECORD_VALUE:
      payload = (<SetClodFlareOriginalRecord>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          cloudflareData: {
            ...state[payload.websiteId].cloudflareData,
            originalRecord: payload.originalRecord,
          },
          loading: false,
          loaded: true,
        }
      };

      case SET_SETTINGS_VALUES:
      payload = (<SetSettingsValues>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          cloudflareData: {
            ...state[payload.websiteId].cloudflareData,
            cacheRules: {
              ...state[payload.websiteId].cloudflareData.cacheRules,
              bypassCookie: payload.settingsValues.bypassCookie,
              bypassPageUrlRegex: payload.settingsValues.bypassPageUrlRegex,
              includeQueryString: payload.settingsValues.includeQueryString
            },
          },
          loading: false,
          loaded: true,
        }
      };

    case SET_FULL_PAGE_CACHE_DISABLED:
      payload = (<SetFullPageCacheDisabled>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          cloudflareData: {
            ...state[payload.websiteId].cloudflareData,
            cacheRules: {
              ...state[payload.websiteId].cloudflareData.cacheRules,
              disablePageCache: payload.fullPageCacheDisabled
            }
          },
          loading: false,
          loaded: true,
        }
      };

    case LOAD_CLOUDFLARE_DATA_FAIL:
      payload = (<LoadCloudflareDataFail>action).payload;

      return {
        ...state,
        [payload.websiteId]: {
          ...state[payload.websiteId],
          loading: false,
          loaded: true,
        },
      };

  }

  return state;
}
